import { Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';

@Injectable()
export class PreferredTimePresetProvider implements FormlyFieldConfigPresetProvider {
  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Preferred Contact Time',
        placeholder: 'Please Select',
        options: [
          { label: '9am - 12pm', value: '9am - 12pm' },
          { label: '2pm - 4pm', value: '2pm - 4pm' },
          { label: '4pm - 6pm', value: '4pm - 6pm' },
        ],
      },
    };
  }
}

export function registerPreferredTimePreset(): ConfigOption {
  return { presets: [{ name: 'preferredTime', config: new PreferredTimePresetProvider() }] };
}
